import {BreakpointObserver, MediaMatcher} from '@angular/cdk/layout';
import { Component, ViewChild } from '@angular/core';
import {MatSidenav} from '@angular/material/sidenav';
import { environment } from '../environments/environment';
import { Globals } from './shared/globals';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { filter, withLatestFrom } from 'rxjs';
import { SideNavbarService } from './side-navbar/side-navbar.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  @ViewChild(MatSidenav, { static: true}) sidenav!: MatSidenav;
  events: string[] = [];
  opened: boolean = false;
  isMobile: boolean = false;
  title = {valueFi: 'Opinto-opas', valueEn: 'Study Guide', valueSv: 'Studiehandbok'};
  background = environment.background;
  headerTransparency = environment.headerTransparency;
  periodView = environment.periodView;
  topNavigationBackgroundColor = environment.topNavigationBackgroundColor;
  secondaryFont = environment.secondaryFont;
  curriculumPeriods = environment.curriculumPeriods;

  constructor(
    public globals: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private observer: BreakpointObserver,
    private sideNavbarService: SideNavbarService
  ) { 
    if(this.periodView) {
      const navEnd$ = this.router.events.pipe(filter(e => e instanceof NavigationEnd));
      navEnd$.pipe(withLatestFrom(this.route.queryParams)).subscribe(
        ([navEnd, queryParams]) => {
          if (queryParams['period'] != undefined && (this.curriculumPeriods.includes(queryParams['period']))) {
            // do the thing
          } else {
            // navigate
            console.log('query param missing or invalid')
            this.router.navigate(['/']);
          }
        }
      )
    } else {
      // periodView = false
      // Check for ANY query param
      this.route.queryParams.subscribe(params => {
        if (Object.keys(params).length !== 0) {
          console.log('There should be NO query parameters in this view');
          this.router.navigate(['/']); // or other appropriate action
        } else {
          // No params, proceed as normal
        }
      });
      
    }
  }


  ngOnInit(): void {
    this.isMobile = this.observer.isMatched('(max-width: 1200px)');

    this.sideNavbarService.closeNav$.subscribe(() => {
      this.sidenav?.close();
    });
  }


  ngAfterViewInit() {
    this.observer.observe(['(max-width: 1200px)']).subscribe(res => {
      // Update both mode and opened in ONE go, in next tick:
      setTimeout(() => {
        if (res.matches) {
          this.sidenav.mode = 'over';
          this.sidenav.close();
        } else {
          this.sidenav.mode = 'side';
          this.sidenav.open();
        }
      });
    });
  }
 
}
